import React, { useState , createContext , useEffect } from "react";

const HeaderContext = createContext();


function HeaderProvider({children}) {

    const [minimisedHeader,setMinimisedHeader] = useState(false);

    useEffect(() => {
        setMinimisedHeader(false);
    },[]);
    
    return (
        <HeaderContext.Provider value={{minimisedHeader,setMinimisedHeader}}>
            {children}
        </HeaderContext.Provider>
    )
}

export { HeaderProvider, HeaderContext };